import {createBrowserRouter} from "react-router-dom";
import PublicRoute from "./PublicRoute";
import LoginContext from "../context/AdminDashboard/LoginContext";
import Login from "../pages/auth/Login";
import OtpContext from "../context/AdminDashboard/OtpContext";
import Otp from "../pages/auth/Otp";
import ProtectedRoute from "./ProtectedRoute";
import MainContext from "../context/AdminDashboard/MainContext";
import MainRoute from "./MainRoute";
import Page404 from "../components/404/Page404";
import HomeContext from "../context/AdminDashboard/HomeContext";
import Home from "../pages/AdminDashboard/Home";
import React from "react";
import {userRoutes} from "./UserRoutes";
import {orderRoutes} from "./OrderRoutes";
import deviceRoutes from "./DeviceRoutes";
import NoInternetConnection from "../pages/AdminDashboard/NoInternetConnection/NoInternetConnection";
import {TransactionProvider} from "../pages/transaction/TransactionContext";
import TransactionScreen from "../pages/transaction/TransactionScreen";
import {ConfigContextProvider} from "../pages/configs/ConfigContext";
import ConfigScreen from "../pages/configs/ConfigScreen";
import {StorehouseProvider} from "../pages/storehouse/StorehouseContext";
import StorehouseScreen from "../pages/storehouse/StorehouseScreen";
import Invoice from "../pages/transaction/component/Invoice";

class AppRouter {
    static router = createBrowserRouter([

        {
            path: "/",
            element: (
                <PublicRoute>
                    <LoginContext>
                        <Login/>
                    </LoginContext>

                </PublicRoute>


            ),

        },
        {
            path: "otp",
            element: (
                <PublicRoute>
                    <LoginContext>
                        <OtpContext>
                            <Otp/>
                        </OtpContext>
                    </LoginContext>
                </PublicRoute>


            )
        },

        {
            path: "admin",
            element: (
                <NoInternetConnection>
                    <ProtectedRoute>
                        <MainContext>
                            <MainRoute/>
                        </MainContext>
                    </ProtectedRoute>
                </NoInternetConnection>
            ),
            children: [
                {
                    index: true,
                    element: <Page404/>
                },
                {

                    path: "home",
                    element: (
                        <HomeContext>
                            <Home/>
                        </HomeContext>


                    )
                },
                userRoutes,
                orderRoutes,
                deviceRoutes,
                {
                    path: "storehouse",
                    element: (
                        <StorehouseProvider>
                            <StorehouseScreen/>
                        </StorehouseProvider>
                    )
                }, {
                    path: "transaction",
                    element: (
                        <TransactionProvider>
                            <TransactionScreen/>
                        </TransactionProvider>
                    )
                },
               /* {
                    path: "invoice",
                    element: (
                            <Invoice/>
                    )
                },*/
                {
                    path: "system",
                    element: (
                        <ConfigContextProvider>
                            <ConfigScreen/>
                        </ConfigContextProvider>

                    )
                },

            ]
        },
        {
            path: "*",
            element: <Page404/>
        },
    ])
}

export default AppRouter;